import NumberFlow from "@number-flow/react"
import { Flex, Space, Typography } from "antd"
import { useTranslation } from "react-i18next"

import Private from "../../../Components/Private"
import { useAnimatedNumber } from "../../../hooks/useAnimatedNumber"

const { Text } = Typography

export const CardTotalPanel = ({
  count,
  volume,
  showVolume = true,
  style,
  isMobile,
  compareCount,
  compareVolume,
  compareLabel
}) => {
  const { t } = useTranslation()
  const animatedCount = useAnimatedNumber(count)
  const animatedVolume = useAnimatedNumber(volume)
  const animatedCompareCount = useAnimatedNumber(compareCount)
  const animatedCompareVolume = useAnimatedNumber(compareVolume)

  const hasCompareCount = compareCount != null
  const hasCompareVolume = compareVolume != null
  const label = compareLabel || t("previous period")

  return (
    <Flex gap={40} style={{ marginBottom: 32, ...style }}>
      <Space direction="vertical" size={7}>
        <Text style={{ fontSize: 14, lineHeight: "20px" }} type="secondary">
          {t("Count")}
        </Text>
        <Text
          style={{
            fontSize: !isMobile ? 24 : 16,
            lineHeight: !isMobile ? "29px" : "20px"
          }}
        >
          {count ? (
            <Private>
              <NumberFlow value={animatedCount} format={{ maximumFractionDigits: 0 }} />
            </Private>
          ) : (
            "-"
          )}
        </Text>
        {hasCompareCount && (
          <Text type="secondary" style={{ fontSize: !isMobile ? 13 : 11 }}>
            <Private>
              <NumberFlow value={animatedCompareCount} format={{ maximumFractionDigits: 0 }} />
            </Private>{" "}
            {label}
          </Text>
        )}
      </Space>
      {showVolume ? (
        <Space direction="vertical" size={7}>
          <Text style={{ fontSize: 14, lineHeight: "20px" }} type="secondary">
            {t("Volume")}
          </Text>
          <Text
            style={{
              fontSize: !isMobile ? 24 : 16,
              lineHeight: !isMobile ? "29px" : "20px"
            }}
          >
            {volume ? (
              <Private>
                <NumberFlow
                  value={animatedVolume}
                  prefix="$"
                  format={{
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }}
                />
              </Private>
            ) : (
              "-"
            )}
          </Text>
          {hasCompareVolume && (
            <Text type="secondary" style={{ fontSize: !isMobile ? 13 : 11 }}>
              <Private>
                <NumberFlow
                  value={animatedCompareVolume}
                  prefix="$"
                  format={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }}
                />
              </Private>{" "}
              {label}
            </Text>
          )}
        </Space>
      ) : null}
    </Flex>
  )
}
